var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.user)?_c('div',{staticClass:"wrapper"},[_c('app-header',{attrs:{"user":_vm.user}}),_c('admin-template',[_c('transition',[_c('keep-alive',[_c('router-view')],1)],1)],1)],1):_c('div',{staticClass:"login"},[_c('app-header',{attrs:{"user":_vm.user}}),_c('transition',[_c('keep-alive',[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }